/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserReference = {
    type?: UserReference.type;
    display?: (string | null);
    identifier?: null;
    reference: string;
    id: number;
};

export namespace UserReference {

    export enum type {
        PRACTITIONER = 'Practitioner',
    }


}

